module.exports = function() {
  return new Worker(__webpack_public_path__ + "dd388570472967f551ad.worker.js");
};